import {isMobileWorkerRegisterFlow, redirectToMobileWorkerRegisterFlow} from "@/helpers/environment";
import {EventBus}                                                       from "@/plugins/event-bus";
import {ReactNativeMessages}                                            from "@/mixins/reactNativeChannel";
import debuglog                                                         from "@/helpers/debuglog";

export const ACCESS_TOKEN_LOCAL_STORAGE_KEY = "sitecircle_access_token";
export const DEVICE_ID_LOCAL_STORAGE_KEY = "sitecircle_device_id";

const LocalStorage = {

  setTokenWithoutNotify(token) {
    this.setTokenWithOptions(token, true)
  },

  setTokenAndNotifyParent(token) {
    this.setTokenWithOptions(token, false)
  },

  setTokenWithOptions(token, blockNotify = false) {
    let oldToken = LocalStorage.getToken();
    window.localStorage.setItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY, token);

    if (!blockNotify && oldToken !== token) {
      this.forceNotifyNewToken();
    }
  },
  /**
   * u can subscribe to new token events
   */
  forceNotifyNewToken() {
    console.log('forceNotifyNewToken()')
    let token = this.getToken();
    debuglog("Notifying new token", token);
    EventBus.$emit('auth-new-token-received', {token: token});

  },

  getToken() {
    const token = window.localStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
    return token === 'null' ? null : token
  },
  /**
   * removes token and redirects to login page
   */
  removeToken() {
    window.localStorage.removeItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
    if (isMobileWorkerRegisterFlow({path: window.location.pathname})) {
      redirectToMobileWorkerRegisterFlow();
    } else {
      // redirect('/login');
      //force page reload to clear application state
      window.location.href = window.location.origin + '/login';
    }
  },
  /**
   * Sugar for running action on new token saved to local storage
   * @param eventName
   * @param callback
   */
  listenForNewToken(callback) {
    EventBus.$on('auth-new-token-received', ({token}) => {
      callback({token});
    })
  }
};
export default LocalStorage;
